<template>
    <div class="lr-page">
        <div class="lr-intro">
            <span class="lr-intro__icon" aria-hidden="true">
                <i class="pi pi-directions" />
            </span>
            <div>
                <h1 class="lr-intro__title">Label Rename</h1>
                <p class="lr-intro__text">
                    Map system labels to the language your organisation uses.
                    Changes show up in menus, screens, and reports after save.
                </p>
            </div>
        </div>

        <LabelRenameForm />
    </div>
</template>

<script setup>
import { onMounted } from 'vue';
import LabelRenameForm from '../components/LabelRenameForm.vue';
import { labelRenameStore } from '../../../store/global-stores';

onMounted(async () => {
    await labelRenameStore.fetchRenameLabels();
});
</script>
